import React from 'react';

import withErrorLogger from '../../../../hoc/withErrorLogger';
import AssetFormsError from '../../../../RequestError/RequestError';

export const AssetFormsErrorWithLogger = withErrorLogger(AssetFormsError);

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorInfo: null,
      errorLog: null,
    };
  }

  componentDidCatch(error, errorInfo) {
    const errorLog = {
      log_type: 'Forms_Error',
      log_message: error ? error.toString() : 'React runtime error',
      error: errorInfo.componentStack.toString(),
    };

    this.setState({
      errorInfo,
      errorLog,
    });
  }

  render() {
    const { errorInfo, errorLog } = this.state;
    const { children } = this.props;

    if (errorInfo) {
      return <AssetFormsErrorWithLogger errorLog={errorLog} source="JSRuntime" displayNextSteps />;
    }

    return children;
  }
}

export default ErrorBoundary;
